module.exports = __webpack_public_path__ + "static/deanfil@2x-768f8865a436d8b3aadd3bb8d4c440bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/deanfil@2x.jpg
// module id = 932
// module chunks = 18116671869107 235176306749093